<template>
  <div>
    <Toolbar classes="pt-3">
      <template v-slot:actions>
        <div class="d-flex align-items-center">
          <router-link :to="backRoute" class="btn btn-sm btn-primary">
            <i class="bi bi-arrow-left me-1"></i>
            Voltar
          </router-link>
        </div>
      </template>
    </Toolbar>

    <div class="container-xxl">
      <div v-if="!canManage" class="alert alert-warning">
        Você não tem permissão para gerenciar a forma de pagamento.
      </div>

      <template v-else>
        <div class="card mb-5">
          <div class="card-header">
            <h3 class="card-title">Forma de pagamento</h3>
          </div>
          <div class="card-body">
            <p class="text-muted mb-4">
              Escolha como deseja pagar a mensalidade Ubbi após o período de teste.
              A cobrança mensal ocorre no dia 1; boletos vencem no dia 10.
            </p>

            <div class="mb-4">
              <label class="form-label d-block">Método preferencial</label>
              <div class="form-check mb-2">
                <input
                  id="pm-card"
                  v-model="selectedMethod"
                  class="form-check-input"
                  type="radio"
                  value="credit_card"
                />
                <label class="form-check-label" for="pm-card">Cartão de crédito (cobrança automática)</label>
              </div>
              <div class="form-check">
                <input
                  id="pm-boleto"
                  v-model="selectedMethod"
                  class="form-check-input"
                  type="radio"
                  value="bank_slip"
                />
                <label class="form-check-label" for="pm-boleto">Boleto bancário (enviado por e-mail mensalmente)</label>
              </div>
            </div>

            <button
              v-if="selectedMethod === 'bank_slip'"
              class="btn btn-primary"
              :disabled="saving"
              @click="saveBankSlip"
            >
              Salvar boleto como forma de pagamento
            </button>
          </div>
        </div>

        <div v-if="selectedMethod === 'credit_card'" class="card">
          <div class="card-header">
            <h3 class="card-title">Cartão de crédito</h3>
          </div>
          <div class="card-body">
            <div v-if="paymentMethod?.card" class="alert alert-light-primary mb-4">
              Cartão cadastrado:
              <strong>{{ paymentMethod.card.card_brand || 'Cartão' }}</strong>
              final <strong>{{ paymentMethod.card.card_last_digits }}</strong>
            </div>
            <PlatformSubscriptionCardForm
              ref="cardForm"
              :loading="saving"
              submit-label="Salvar cartão"
              @submit="saveCard"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Toolbar from '../../components/layouts/auth/Toolbar.vue';
import PlatformSubscriptionCardForm from './PlatformSubscriptionCardForm.vue';
import http from '../../helpers/http';
import Alert from '../../helpers/alert';
import Permission from '../../helpers/permission';

export default {
  name: 'SubscriptionPaymentMethod',
  components: { Toolbar, PlatformSubscriptionCardForm },
  data() {
    return {
      paymentMethod: null,
      selectedMethod: 'credit_card',
      saving: false,
    };
  },
  computed: {
    canManage() {
      return Permission.has('Manage Place Platform Subscription');
    },
    isFirstSubscription() {
      const value = this.$route.query.first_subscription;

      return value === '1' || value === 'true';
    },
    backRoute() {
      return this.isFirstSubscription
        ? { path: '/dashboard' }
        : { path: '/subscription' };
    },
  },
  created() {
    if (!this.canManage) {
      return;
    }
    this.load();
  },
  methods: {
    load() {
      const placeId = this.$store.state.auth.place?.id_place;
      if (!placeId) return;

      http.get(`/places/${placeId}/platform-subscription/payment-method`).then((res) => {
        this.paymentMethod = res.data;
        if (res.data.payment_method) {
          this.selectedMethod = res.data.payment_method;
        }
      });
    },
    saveBankSlip() {
      this.saving = true;
      const placeId = this.$store.state.auth.place.id_place;

      http.put(`/places/${placeId}/platform-subscription/payment-method`, {
        payment_method: 'bank_slip',
      }).then((res) => {
        this.paymentMethod = res.data;
        Alert.success('Forma de pagamento atualizada para boleto.');
        this.refreshSubscription().then(() => this.afterPaymentMethodSaved());
      }).finally(() => {
        this.saving = false;
      });
    },
    saveCard() {
      this.saving = true;
      const placeId = this.$store.state.auth.place.id_place;
      const payload = this.$refs.cardForm.payload();

      http.post(`/places/${placeId}/platform-subscription/payment-method/tokenize`, payload)
        .then((res) => {
          this.paymentMethod = res.data.payment_method;
          if (res.data.subscription) {
            this.$store.commit('auth/setPlatformSubscription', res.data.subscription);
          }
          Alert.success('Cartão salvo com sucesso.');

          return this.afterPaymentMethodSaved(res.data.subscription);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    refreshSubscription() {
      const placeId = this.$store.state.auth.place.id_place;

      return http.get(`/places/${placeId}/platform-subscription`).then((res) => {
        this.$store.commit('auth/setPlatformSubscription', res.data);

        return res.data;
      });
    },
    async afterPaymentMethodSaved(subscription = null) {
      const summary = subscription ?? this.$store.state.auth.platformSubscription;

      if (summary?.is_blocked) {
        Alert.toastInfo('Ainda há pendências. Verifique as faturas em aberto.');
        this.$router.push('/subscription/overdue');

        return;
      }

      if (this.isFirstSubscription) {
        await this.$store.dispatch('auth/refreshEntitlements');
        this.$router.push('/dashboard');

        return;
      }

      this.$router.push('/subscription');
    },
  },
};
</script>
